module.exports = __webpack_public_path__ + "static/media/indonesia-tourism-board.857c5187.jpg";